import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
// import im from '/_WHTML/Item Master(DONE).html';
// var perf =require('./_W');
import { useDispatch } from "react-redux";
import { makeActive } from "../dataStore/slice/ActiveSlice";

const WordFrame = React.memo(() => {
	const dispatch = useDispatch();

	const location = useLocation();
	// console.log(location.search);
	/* if (location.state) {
		const datapath = location.state?.path;
	} */
	const q = new URLSearchParams(location.search);
	const file = q.get("data");
	// console.log(file);

	useEffect(() => {
		dispatch(makeActive(`${file}`));
	});

	/* document.getElementById("wordframe").addEventListener("keydown", (e) => {
		if (e.key.toLowerCase() === "/") {
			document.getElementById("bsearch").focus();
			e.preventDefault();
			// alert('welcome jck');
		}
		if (e.key === "Escape") {
			document.getElementById("bsearch").blur();
			// console.log('alert');
		}
	}); */

	// console.log(location.search.get('data'));
	// return <iframe src="/_WHTML/Item Master(DONE).html" title="iframe"></iframe>;
	// return <iframe src="./_WHTML/Item Master(DONE).html" title="iframe"></iframe>;
	// return <iframe src={datapath} title="iframe"></iframe>;
	return (
		<>
			<Helmet>
				<title>Plus Help - {file}</title>
			</Helmet>
			<iframe src={`/_WHTML/${file}.html`} title="iframe" id="wordframe">
				<p>hello</p>
			</iframe>
		</>
	);
	// return <iframe src={im} title="iframe"></iframe>;

	// return <div className="framediv">JIGAR</div>
});

export default WordFrame;
